import '../../../scss/hotfood/components/hotfood-fable.scss'

import {
  Body1,
  Button,
  ButtonGroup,
  ButtonGroupSection,
  Modal,
} from '@sainsburys-tech/fable'
import React from 'react'

interface IProps {
  skuName: string
  handleClose: () => void
  handleSoldOut: () => void
  isOpen: boolean
}

const getMessageContent = (skuName: string) => (
  <Body1>
    Please confirm that you no longer have any {skuName} on display available
    for sale.
  </Body1>
)

const SoldOutModal = (props: IProps) => (
  <Modal
    size='sm'
    onClose={() => props.handleClose()}
    isOpen={props.isOpen}
    testid='info-modal'
    header={{ label: `Have you sold out of ${props.skuName}?` }}
  >
    {getMessageContent(props.skuName)}
    <div style={{ marginTop: 'var(--fable-spacing-lg, 1.5rem)' }}>
      <ButtonGroup orientation='horizontal' gap='md'>
        <ButtonGroupSection className='hotfood-full-width'>
          <Button
            onClick={() => props.handleSoldOut()}
            testid='sold-out-button'
          >
            Sold out
          </Button>

          <Button
            onClick={() => props.handleClose()}
            variant='secondary'
            style={{ backgroundColor: 'var(--fable-color-background, #fff)' }}
            testid='cancel-button'
          >
            Cancel
          </Button>
        </ButtonGroupSection>
      </ButtonGroup>
    </div>
  </Modal>
)

export default SoldOutModal
